// components/timer/TimerControls.tsx
import React from "react";
import {
    PlayIcon,
    PauseIcon,
    BackwardIcon,
    ForwardIcon,
} from "@heroicons/react/24/solid";

interface TimerControlsProps {
    isRunning: boolean;
    onStartPause: () => void;
    onPrevLevel: () => void;
    onNextLevel: () => void;
}

export default function TimerControls({
                                          isRunning,
                                          onStartPause,
                                          onPrevLevel,
                                          onNextLevel,
                                      }: TimerControlsProps) {
    return (
        <div className="absolute top-4 right-4 flex gap-4 z-10">
            <button onClick={onPrevLevel} title="Vorheriges Level">
                <BackwardIcon className="w-8 h-8 text-white" />
            </button>
            <button onClick={onStartPause} title="Start/Pause">
                {isRunning ? (
                    <PauseIcon className="w-8 h-8 text-white" />
                ) : (
                    <PlayIcon className="w-8 h-8 text-white" />
                )}
            </button>
            <button onClick={onNextLevel} title="Nächstes Level">
                <ForwardIcon className="w-8 h-8 text-white" />
            </button>
        </div>
    );
}
